import CellLocation from '../components/Table/components/CellLocation'
import React from 'react'

const defaultFilters = [
    {
        filterGrupName: 'Ownership',
        field: 'categoryType',
        filters: [
            {
                filterName: 'Rented',
                checked: false,
            },
            {
                filterName: 'Owned',
                checked: false,
            },
        ],
    },
    {
        filterGrupName: 'Equipment',
        field: 'simpleType',
        filters: [
            {
                filterName: 'Aerial Lifts',
                checked: false,
            },
            {
                filterName: 'Automations',
                checked: false,
            },
            // {
            //     filterName: 'Batteries',
            //     checked: false,
            // },
            // {
            //     filterName: 'Chargers',
            //     checked: false,
            // },
            {
                filterName: 'Forklifts',
                checked: false,
            },
            {
                filterName: 'Pallet Trucks',
                checked: false,
            },
            {
                filterName: 'Rail and Transit',
                checked: false,
            },
            {
                filterName: 'Warehouse Vehicles and Operated Machinery',
                checked: false,
            },
            {
                filterName: 'Warehouse Accessories',
                checked: false,
            },
            {
                filterName: 'Legacy',
                checked: false,
            },
            {
                filterName: 'Other',
                checked: false,
            },
        ],
    },
    {
        filterGrupName: 'Location',
        field: 'shipToSalesforceId',
        filters: [],
    },
]

const renderLocation = (address, name) => (
    <CellLocation address={address} label={name} isInCard />
)

export const getInitialFilters = (mylocations, appliedFilters) => {
    return defaultFilters?.map(fil => {
        if (fil?.filterGrupName === 'Location') {
            return {
                ...fil,
                filterGrupName: 'Location',
                filters: mylocations.map(item => {
                    return {
                        checked:
                            appliedFilters?.locationFilters?.includes(
                                item?.value,
                            ) || false,
                        customRender: () =>
                            renderLocation(item?.address, item?.label),
                        filterName: item?.address,
                        shiptoId: item?.value,
                        isLocation: true,
                    }
                }),
            }
        }
        if (fil?.filterGrupName === 'Ownership') {
            return {
                ...fil,
                filters: fil?.filters?.map(filter => ({
                    ...filter,
                    checked: appliedFilters?.ownershipFilters?.includes(
                        filter?.filterName,
                    ),
                })),
            }
        }
        if (fil?.filterGrupName === 'Equipment') {
            return {
                ...fil,
                filters: fil?.filters?.map(filter => ({
                    ...filter,
                    checked: appliedFilters?.equipmentFilters?.includes(
                        filter?.filterName,
                    ),
                })),
            }
        }
        return fil
    })
}

export const getFormattFilters = filters => {
    let equipmentFilters = []
    let locationFilters = []
    let ownershipFilters = []
    let filtersCount = 0

    filters?.forEach(filterGroup => {
        filterGroup?.filters?.forEach(filter => {
            if (filter?.checked) {
                filtersCount++
                if (filterGroup?.filterGrupName === 'Ownership') {
                    ownershipFilters.push(filter?.filterName)
                } else if (filterGroup?.filterGrupName === 'Equipment') {
                    equipmentFilters.push(filter?.filterName)
                } else if (filterGroup?.filterGrupName === 'Location') {
                    locationFilters.push(filter?.shiptoId)
                }
            }
        })
    })

    return {
        count: filtersCount,
        equipmentFilters: equipmentFilters,
        filterApplied: filtersCount > 0,
        locationFilters: locationFilters,
        ownershipFilters: ownershipFilters,
        query: '',
    }
}
